<script>
import UebungenLibraryCuratedUebungCard from "./UebungenLibraryCuratedUebungCard.vue";

export default {
  name: "uebungen-library-curated-category-tile",
  components: {
    UebungenLibraryCuratedUebungCard
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    categoryAlias: {
      type: String,
      required: true
    },
    uebungenByModule: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isHovered: false
    };
  },
  computed: {
    totalUebungenCount() {
      return Object.values(this.uebungenByModule).reduce((sum, module) => sum + module.uebungen.length, 0);
    },
    categoryIcon() {
      return `hi-uebung-category-${this.categoryAlias}`;
    },
    trueColorCategoryIcon() {
      return `hi-tc-uebung-category-${this.categoryAlias}`;
    },
    categoryColor() {
      return this.category.color || "#4CAF50";
    },
    moduleEntries() {
      return Object.entries(this.uebungenByModule);
    }
  },
  methods: {
    getModuleIcon(moduleAlias) {
      const registryUebung = this.$UebungenRegistry?.registered_uebungen?.[moduleAlias];
      return registryUebung?.appearance?.icon || "hi-uebung-default";
    },
    getModuleTitle(moduleAlias) {
      const registryUebung = this.$UebungenRegistry?.registered_uebungen?.[moduleAlias];
      return registryUebung?.title || moduleAlias;
    }
  }
}
</script>

<template>
  <div class="bg-white shadow-md border border-grey-200 overflow-hidden"
       :style="{ borderTopColor: categoryColor, borderTopWidth: '3px', borderTopStyle: 'solid' }"
       @mouseenter="isHovered = true"
       @mouseleave="isHovered = false">
    <!-- Header -->
    <div class="flex items-center gap-3 p-5 border-b border-grey-200">
      <div class="flex-shrink-0 relative"
           style="width: 64px; height: 64px;"
           :style="{ color: categoryColor }">
        <hermeneus-icon
          :name="trueColorCategoryIcon"
          height="64" width="64"
          :preserve-colors="true"
          class="absolute inset-0 transition-opacity duration-300"
          :style="{ opacity: isHovered ? 1 : 0 }">
        </hermeneus-icon>
        <hermeneus-icon
          :name="categoryIcon"
          height="64" width="64"
          color="current"
          class="absolute inset-0 transition-opacity duration-300"
          :style="{ opacity: isHovered ? 0 : 1 }">
        </hermeneus-icon>
      </div>
      <div class="flex flex-col justify-center flex-1">
        <h2 class="text-xl uppercase font-bold text-grey-800 leading-tight tracking-wide">
          {{ category.title }}
        </h2>
      </div>
      <span class="bg-grey-100 text-grey-600 text-xs px-2 py-0.5 rounded-full">
        {{ totalUebungenCount }} {{ totalUebungenCount === 1 ? 'Übung' : 'Übungen' }}
      </span>
    </div>

    <!-- Modul-Gruppen -->
    <div v-for="([moduleAlias, moduleData]) in moduleEntries" :key="moduleAlias">
      <!-- Modul-Header -->
      <div class="flex items-center gap-3 px-5 py-2.5 bg-grey-50 border-b border-grey-100">
        <div class="flex-shrink-0 text-grey-500">
          <hermeneus-icon
            :name="getModuleIcon(moduleAlias)"
            height="36" width="36"
            color="current">
          </hermeneus-icon>
        </div>
        <span class="text-lg font-semibold text-grey-700">
          {{ getModuleTitle(moduleAlias) }}
        </span>
        <span class="text-base text-grey-400">
          ({{ moduleData.uebungen.length }})
        </span>
      </div>

      <!-- Übungen in diesem Modul -->
      <div>
        <UebungenLibraryCuratedUebungCard
          v-for="uebung in moduleData.uebungen"
          :key="uebung.id"
          :uebung="uebung"
          :category-color="categoryColor"
        />
      </div>
    </div>
  </div>
</template>
